// The endpoint's outcomes are not a boolean, and two of them are traps `history_recorded: false` IS
// A SUCCESS WITH A CAVEAT. The file IS in Ops Center; only the history row failed.
import { ApiError } from "../api/client";
import type { JdSpreadSendResult } from "../types/contract";

export type JdSendOutcome =
  | { kind: "sent"; result: JdSpreadSendResult }
  | { kind: "sent_unrecorded"; result: JdSpreadSendResult }
  | { kind: "write_approval_missing" }
  | { kind: "failed"; message: string };

export function classifySendResult(result: JdSpreadSendResult): JdSendOutcome {
  return result.history_recorded
    ? { kind: "sent", result }
    : { kind: "sent_unrecorded", result };
}

export function classifySendError(e: unknown): JdSendOutcome {
  if (e instanceof ApiError && e.code === "ERR_FORBIDDEN")
    return { kind: "write_approval_missing" };
  return {
    kind: "failed",
    message: e instanceof Error ? e.message : "The send failed.",
  };
}

/* * The copy for each outcome. One place, so the two send surfaces cannot drift apart. */
export const SEND_OUTCOME_COPY: Record<
  Exclude<JdSendOutcome["kind"], "sent">,
  { title: string; body: string }
> = {
  sent_unrecorded: {
    title: "Sent — but not recorded here",
    body: "The file IS in Ops Center. Our send history failed to record it, so this screen may not show it — do NOT send again, or the operator will see two copies.",
  },
  write_approval_missing: {
    title: "Waiting on John Deere",
    body: "John Deere hasn’t approved file writing for this app yet (the approval is requested). Your connection is fine — no need to reconnect. Try again once the approval lands.",
  },
  failed: {
    title: "The send failed",
    body: "Nothing was created in Ops Center. The details below say why; it’s safe to try again.",
  },
};
